import { InstrumentBase } from '../../utils/instrument-base';
import { FEATURE_NAME } from '../constants';
import { bufferLog } from '../shared/utils';
export class Instrument extends InstrumentBase {
  static featureName = (() => FEATURE_NAME)();
  constructor(agentIdentifier, aggregator) {
    let auto = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    super(agentIdentifier, aggregator, FEATURE_NAME, auto);
    const instanceEE = this.ee;
    /** emitted by wrap-logger function */
    this.ee.on('wrap-logger-end', function handleLog(_ref) {
      let [message] = _ref;
      const {
        level,
        customAttributes
      } = this;
      bufferLog(instanceEE, message, customAttributes, level);
    });
    this.importAggregator();
  }
}